export default __webpack_public_path__ + "static/005-19b74dd98927686dde57ebf7bf186478.png";